// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1BeQN","inner":"Form_inner__1zqQ7","range":"Form_range__Koa5A","name":"Form_name__Uy515","actions":"Form_actions__1hMh3"};